import React from 'react';

export const IncludeLegacyContentAnnotationsContext: React.Context<boolean> =
	React.createContext(false);
